import React from 'react'
import { PropTypes } from 'prop-types'

class FeaturedResourceBlock extends React.Component{
	render(){
		let content = <div className="featured-resource" dangerouslySetInnerHTML={{__html: this.props.featuredResourceContent}} />;
        return (
			<div className="container">
				{ content }
			</div>
		)
    }
}

FeaturedResourceBlock.propTypes = {
	featuredResourceContent: PropTypes.string
}
export default FeaturedResourceBlock



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/resource-grid/components/featured-resource.js